import { render, staticRenderFns } from "./SkillStats.vue?vue&type=template&id=a4c6f528&scoped=true&"
import script from "./SkillStats.vue?vue&type=script&lang=js&"
export * from "./SkillStats.vue?vue&type=script&lang=js&"
import style0 from "./SkillStats.vue?vue&type=style&index=0&id=a4c6f528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c6f528",
  null
  
)

export default component.exports